import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 32,
  medium: 24,
  small: 18,
  xSmall: 14
};
const FavoriteNavFilledIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.6951 7.09156C3.49859 9.29305 3.43021 12.8518 5.53178 15.106L5.68872 15.2692L15.0022 24.6039L24.2843 15.3011L24.4416 15.1385C26.57 12.8563 26.51 9.29736 24.3092 7.09156L24.1233 6.91321C21.8569 4.83246 18.3351 4.89191 16.1404 7.09156L15.0015 8.232L13.8639 7.09156C11.6693 4.89191 8.14741 4.83246 5.88101 6.91321L5.6951 7.09156Z",
        fill: "currentColor"
      }
    )
  );
};
FavoriteNavFilledIcon.iconName = "FavoriteNavFilledIcon";

export { FavoriteNavFilledIcon };
